<template>
  <div>
    <wtForm>
      <template slot="left">
        <SecurityProviderFilter :providerType="providerType"></SecurityProviderFilter>
      </template>

      <template slot="right">
        <SecurityProvider :providerType="providerType"></SecurityProvider>
      </template>
    </wtForm>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/** COMPONENTS - LAYOUT **/
import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import SecurityProvider from "@/modules/security_ds/internal/security_provider/SecurityProvider";
import SecurityProviderFilter from "@/modules/security_ds/internal/security_provider/SecurityProviderFilter";

export default {
  name: "SecurityProviderContainer",
  components: { wtForm, SecurityProvider, SecurityProviderFilter },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    }
  },

  data: function() {
    return {
      providerType: [{ value: null, text: "---" }]
    };
  },
  methods: {
    mudarTab() {
      this.$nextTick(() => {
        this.tabIndex++;
      });
    },
    getSecurityProviderType() {
      const urlService = "security-ds/api/internal/security-provider-type";
      axios
        .post(`${baseApiUrl}:${baseApiPort}/${urlService}/find-all`)
        .then(res => {
          res.data.forEach(element => {
            this.providerType.push({
              value: element.security_provider_type_data.description,
              text: element.security_provider_type_data.description
            });
          });
        });
    }
  },
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "security-ds/api/internal/security-provider"
    );
  },
  mounted() {
    this.getSecurityProviderType();
  },
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>

<style>
</style>
